export const getApiUrl = (endpoint) => {
  const path = window.location.pathname;
  const match = path.match(/^\/products\/([^/]+)/);
  if (match) {
    // Strip '/api' from the start if it exists
    const cleanEndpoint = endpoint.startsWith('/api') ? endpoint.slice(4) : endpoint;
    const slash = cleanEndpoint.startsWith('/') ? '' : '/';
    return `/api/products/${match[1]}${slash}${cleanEndpoint}`;
  }
  return endpoint;
};
